/* Magnetix IL — 3D poster builder (mgx-poster-builder.js). Port of the MagnetixTiles poster builder, Hebrew + RTL.
 * Gallery (3D + product photos + thumbnails) -> upload -> full-screen crop -> live 3D -> cart -> "added" panel
 * (checkout, or add another poster). Line-item properties: `_Image URL` original, `_Print File` exact crop at full
 * resolution, `_Preview URL` 600px crop for the cart, `_Session ID` + `_Builder: poster` for the cart Edit link.
 */
(function () {
  'use strict';

  function $(id) { return document.getElementById(id); }
  var root = $('mtp'), cfgEl = $('mtp-config');
  if (!root || !cfgEl) return;
  var CFG = JSON.parse(cfgEl.textContent);

  var CLOUD = 'du3eofguy';
  var PRESET = 'magnetixtiles_uploads';
  var SESSION_PREFIX = 'mtp_sess_';

  // Short side x long side in cm (all 2:3). Orientation decides which way round.
  var SIZES = [
    { id: 'M', a: 20, b: 30 },
    { id: 'L', a: 30, b: 45 },
    { id: 'XL', a: 40, b: 60 }
  ];
  var FINISHES = [
    { id: 'gloss', label: 'מבריק', sub: 'ברק כמו זכוכית', re: /מבריק|gloss/i },
    { id: 'matte', label: 'מאט', sub: 'בלי השתקפויות', re: /מאט|mat/i }
  ];

  var state = {
    size: 'M', orientation: 'portrait', finish: 'gloss', effect: 'original', notes: '',
    url: '', natW: 0, natH: 0, fileName: '',
    cropXf: 0, cropYf: 0, cropScale: 1
  };
  var uploading = false, uploadPct = 0, uploadToken = 0;
  var srcImg = null;
  var editingSessionId = null, editingCartKeys = [];

  function sizeById(id) { for (var i = 0; i < SIZES.length; i++) if (SIZES[i].id === id) return SIZES[i]; return SIZES[0]; }
  function dims() { var s = sizeById(state.size); return state.orientation === 'portrait' ? { w: s.a, h: s.b } : { w: s.b, h: s.a }; }
  function ratio() { var d = dims(); return d.w / d.h; }
  function dimsLabel(sizeId) { var s = sizeById(sizeId); return state.orientation === 'portrait' ? s.a + '×' + s.b : s.b + '×' + s.a; }
  function orientLabel() { return state.orientation === 'portrait' ? 'לאורך' : 'לרוחב'; }
  function finishById(id) { return FINISHES[0].id === id ? FINISHES[0] : FINISHES[1]; }

  // ---------- Variants & money ----------
  function sizeKey(str) {
    var m = String(str || '').match(/(\d+)\s*[x×X]\s*(\d+)/);
    if (!m) return '';
    var a = +m[1], b = +m[2];
    return Math.min(a, b) + 'x' + Math.max(a, b);
  }
  function variantFor(sizeId, finish) {
    var s = sizeById(sizeId), want = s.a + 'x' + s.b, re = finishById(finish).re;
    for (var i = 0; i < CFG.variants.length; i++) {
      var v = CFG.variants[i];
      if ((sizeKey(v.o1) || sizeKey(v.o2)) === want && (re.test(v.o1 || '') || re.test(v.o2 || ''))) return v;
    }
    return null;
  }
  // "₪129", kept left of the number inside Hebrew text
  function money(cents) {
    var n = cents / 100;
    return '⁦₪' + (n % 1 === 0 ? n.toLocaleString('en-US') : n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })) + '⁩';
  }
  // Start from the variant in the URL (or the first one)
  (function initFromVariant() {
    var v = null;
    CFG.variants.forEach(function (x) { if (x.id === CFG.selectedVariant) v = x; });
    if (!v) return;
    var key = sizeKey(v.o1) || sizeKey(v.o2);
    SIZES.forEach(function (s) { if (s.a + 'x' + s.b === key) state.size = s.id; });
    FINISHES.forEach(function (f) { if (f.re.test(v.o1 || '') || f.re.test(v.o2 || '')) state.finish = f.id; });
  })();

  // ---------- Option chips ----------
  function chip(container, opts) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'mtp-opt';
    b.setAttribute('role', 'radio');
    b.innerHTML = '<span class="mtp-opt-main">' + opts.main + '</span>' + (opts.sub ? '<span class="mtp-opt-sub">' + opts.sub + '</span>' : '');
    b.setAttribute('aria-checked', opts.on ? 'true' : 'false');
    b.addEventListener('click', opts.pick);
    container.appendChild(b);
  }
  function renderOptions() {
    var box = $('mtp-sizes');
    box.innerHTML = '';
    SIZES.forEach(function (s) {
      var v = variantFor(s.id, state.finish);
      if (!v) return;
      chip(box, { main: dimsLabel(s.id), sub: money(v.price), on: state.size === s.id, pick: function () { state.size = s.id; changed(); showChange(); } });
    });
    $('mtp-size-val').textContent = dimsLabel(state.size) + ' ס״מ · ' + orientLabel();

    box = $('mtp-finishes');
    box.innerHTML = '';
    FINISHES.forEach(function (f) {
      chip(box, { main: f.label, sub: f.sub, on: state.finish === f.id, pick: function () { state.finish = f.id; changed(); showChange(); } });
    });
    $('mtp-finish-val').textContent = finishById(state.finish).label;

    var v = variantFor(state.size, state.finish);
    var eff = v ? effectivePrice(v.price) : 0;
    $('mtp-price').innerHTML = !v ? '' : eff < v.price
      ? '<s>' + money(v.price) + '</s> ' + money(eff) + '<small>' + esc(effectiveNote()) + '</small>'
      : money(v.price);
  }

  // ---------- Poster discount on this page (automatic in the cart, posters only) ----------
  // 2 posters = 20% off all posters, 3+ = 30% off all. With posters already in the cart, this poster is shown at
  // the price it will have in the cart: its own price minus the discount it unlocks (never the extra the cart grows by,
  // which made the 2nd/3rd poster look cheaper than the 4th).
  var cartPosters = { n: 0, total: 0 }; // without the line being edited
  function tierFor(n) { return n >= 3 ? 0.3 : n === 2 ? 0.2 : 0; }
  function effectivePrice(price) {
    if (!cartPosters.n) return price;
    return Math.round(price * (1 - tierFor(cartPosters.n + 1)));
  }
  function effectiveNote() {
    var off = Math.round(tierFor(cartPosters.n + 1) * 100);
    return off ? 'עם ' + off + '% הנחה על כל הפוסטרים' : '';
  }
  function refreshCartPosters() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var ids = CFG.posterProductIds || [], n = 0, t = 0;
      (cart.items || []).forEach(function (it) {
        if (ids.indexOf(it.product_id) < 0 || editingCartKeys.indexOf(it.key) > -1) return;
        n += it.quantity; t += it.original_line_price;
      });
      cartPosters = { n: n, total: t };
      renderOptions();
      paintButton();
    }).catch(function () {});
  }
  function setOrientation(o) {
    if (o === state.orientation) return;
    state.orientation = o;
    state.cropXf = 0; state.cropYf = 0; state.cropScale = 1; // new frame shape: start from a centered fill
    changed();
  }

  // ---------- Print quality ----------
  function fillNorm() {
    var r = (state.natW && state.natH) ? state.natW / state.natH : (srcImg ? srcImg.naturalWidth / srcImg.naturalHeight : 1);
    var cr = ratio();
    return r >= cr ? { w: r / cr, h: 1 } : { w: 1, h: cr / r };
  }
  function quality() {
    if (!state.natW) return null;
    var dpi = state.natW / (state.cropScale * fillNorm().w * (dims().w / 2.54));
    // Stays positive: lower-resolution photos are enhanced before printing
    return dpi >= 80 ? { cls: 'is-great', text: 'איכות הדפסה מעולה' } : { cls: 'is-great', text: 'איכות טובה · נשפר את התמונה לפני ההדפסה' };
  }
  function paintQuality(el) {
    if (!el) return;
    if (uploading && !state.natW) { el.className = 'mtp-q is-wait'; el.textContent = 'בודקים את איכות התמונה…'; return; }
    var q = quality();
    el.className = 'mtp-q ' + (q ? q.cls : 'is-wait');
    el.textContent = q ? q.text : '';
  }

  // ---------- Crop rendering (same math as the Tiles builder) ----------
  // Blank areas (customer zoomed out) are shown as a light striped area with a note, never as a second copy
  // of the photo (iPhone Safari ignores canvas blur, which made it look like a photo on top of a photo).
  // Production fills them with AI; the print file is built separately by MTH.printFile.
  function paintBlank(ctx, w, h) {
    ctx.fillStyle = '#EDEAE7';
    ctx.fillRect(0, 0, w, h);
    ctx.strokeStyle = '#E1DDD9';
    ctx.lineWidth = Math.max(2, w / 90);
    var step = Math.max(10, w / 28);
    ctx.beginPath();
    for (var x = -h; x < w; x += step) { ctx.moveTo(x, h); ctx.lineTo(x + h, 0); }
    ctx.stroke();
  }
  function blankNote(ctx, rect, outW, outH) {
    // Largest empty band around the photo
    var bands = [
      { x: 0, y: 0, w: outW, h: rect.y },
      { x: 0, y: rect.y + rect.h, w: outW, h: outH - rect.y - rect.h },
      { x: 0, y: 0, w: rect.x, h: outH },
      { x: rect.x + rect.w, y: 0, w: outW - rect.x - rect.w, h: outH }
    ];
    var b = bands.sort(function (p, q) { return q.w * q.h - p.w * p.h; })[0];
    var thin = Math.min(b.w, b.h);
    if (thin < outW * 0.07) return; // a sliver: the striped area says enough
    var vertical = b.h > b.w * 1.4;
    var room = vertical ? b.h : b.w;
    var fs = Math.max(10, Math.min(thin * 0.2, room * 0.055, outW * 0.05));
    ctx.save();
    ctx.translate(b.x + b.w / 2, b.y + b.h / 2);
    if (vertical) ctx.rotate(-Math.PI / 2);
    ctx.fillStyle = 'rgba(70, 64, 60, .85)';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.font = '700 ' + Math.round(fs) + 'px Arial, sans-serif';
    ctx.fillText('נתאים את האזור הריק', 0, -fs * 0.7);
    ctx.font = '400 ' + Math.round(fs * 0.85) + 'px Arial, sans-serif';
    ctx.fillText('הוא לא יופיע במוצר הסופי', 0, fs * 0.7);
    ctx.restore();
  }
  function renderCrop(canvas, outW) {
    var outH = Math.round(outW / ratio());
    canvas.width = outW; canvas.height = outH;
    var ctx = canvas.getContext('2d');
    paintBlank(ctx, outW, outH);
    if (!srcImg) return canvas;
    var r = srcImg.naturalWidth / srcImg.naturalHeight, cr = outW / outH;
    var iW = r >= cr ? outH * r : outW, iH = r >= cr ? outH : outW / r;
    var s = state.cropScale;
    var rect = { w: iW * s, h: iH * s };
    rect.x = outW / 2 + state.cropXf * outW - rect.w / 2;
    rect.y = outH / 2 + state.cropYf * outH - rect.h / 2;
    ctx.drawImage(srcImg, rect.x, rect.y, rect.w, rect.h);
    if (state.effect === 'bw') {
      var id = ctx.getImageData(0, 0, outW, outH), d = id.data;
      for (var i = 0; i < d.length; i += 4) { var g = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; d[i] = d[i + 1] = d[i + 2] = g; }
      ctx.putImageData(id, 0, 0);
    }
    if (rect.x > 1 || rect.y > 1 || rect.x + rect.w < outW - 1 || rect.y + rect.h < outH - 1) blankNote(ctx, rect, outW, outH);
    return canvas;
  }
  function printSpec() {
    return {
      url: state.url, imgRatio: srcImg ? srcImg.naturalWidth / srcImg.naturalHeight : (state.natW / state.natH),
      frameRatio: ratio(), cropXf: state.cropXf, cropYf: state.cropYf, cropScale: state.cropScale,
      bw: state.effect === 'bw', natW: state.natW, natH: state.natH
    };
  }

  // ---------- Gallery: main viewer + thumbnails ----------
  var gallery = $('mtg'), mainEl = $('mtg-main');
  var slides = mainEl ? Array.prototype.slice.call(mainEl.querySelectorAll('.mtg-slide')) : [];
  var thumbBtns = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('.mtg-thumb')) : [];
  var cur = 0;
  slides.forEach(function (s, i) { if (s.classList.contains('is-on')) cur = i; });

  function show(i) {
    if (!slides.length) return;
    i = (i + slides.length) % slides.length;
    cur = i;
    slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
    thumbBtns.forEach(function (t, k) {
      t.classList.toggle('is-on', k === i);
      t.setAttribute('aria-selected', k === i ? 'true' : 'false');
    });
    gallery.classList.toggle('is-3d', i === 0);
    if (i === 0) ensure3D();
    var t = thumbBtns[i], strip = $('mtg-thumbs');
    if (t && strip) {
      var tr = t.getBoundingClientRect(), sr = strip.getBoundingClientRect();
      if (tr.left < sr.left || tr.right > sr.right) strip.scrollBy({ left: tr.left - sr.left - (sr.width - tr.width) / 2, behavior: 'smooth' });
    }
  }
  // After a photo is in, changing size / finish / orientation jumps to the 3D view so the change is visible
  function showChange() { if (srcImg && cur !== 0) show(0); }
  thumbBtns.forEach(function (t) { t.addEventListener('click', function () { show(+t.dataset.i); }); });
  if ($('mtg-prev')) $('mtg-prev').addEventListener('click', function () { show(cur - 1); });
  if ($('mtg-next')) $('mtg-next').addEventListener('click', function () { show(cur + 1); });
  // Swipe between photos (the 3D slide uses drags to rotate)
  if (mainEl) {
    var sx = 0, sy = 0, swiping = false;
    mainEl.addEventListener('touchstart', function (e) {
      swiping = cur !== 0 && e.touches.length === 1;
      if (swiping) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }
    }, { passive: true });
    mainEl.addEventListener('touchend', function (e) {
      if (!swiping) return;
      swiping = false;
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(dx < 0 ? cur + 1 : cur - 1); // RTL: swipe left = next
    }, { passive: true });
  }

  // ---------- 3D preview ----------
  var stage = $('mtp-stage'), viewer = null, creating = false, flatImg = null;
  // Measured: a grey-128 photo renders at 129 (it was 120), red 200/60/60 at 208/72/69
  // Glossy reflection a little softer, so it doesn't wash the photo out
  var LOOK = { glow: 1, shade: 0.15, exposure: 1, gloss: { envMapIntensity: 0.7 } };
  var texCanvas = document.createElement('canvas');
  if (stage) {
    ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
      stage.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
    });
    stage.addEventListener('mtposter:interact', function () { $('mtp-stage-hint').classList.add('is-gone'); });
    $('mtp-stage-cta').addEventListener('click', function () { pickFile(); });
  }
  function ensure3D() {
    if (!stage || viewer || creating) return;
    creating = true;
    if (!window.MTPoster3D) { flatFallback(); return; }
    window.MTPoster3D.create(stage, {
      envImage: CFG.assets.studio,
      backPortrait: CFG.assets.backPortrait,
      backLandscape: CFG.assets.backLandscape,
      finish: state.finish,
      orientation: state.orientation,
      room: 'b3'
    }).then(function (v) {
      $('mtp-stage-load').hidden = true;
      if (!v) { flatFallback(); return; }
      viewer = v;
      // Print as bright as the photo on the customer's phone (the MagnetixTiles look was darker)
      try { viewer.tune(LOOK); } catch (e) {}
      updatePreview();
    }, flatFallback);
  }
  function flatFallback() {
    if (flatImg) return;
    $('mtp-stage-load').hidden = true;
    var wrap = document.createElement('div');
    wrap.className = 'mtp-stage-flat';
    flatImg = document.createElement('img');
    flatImg.alt = 'תצוגה מקדימה של פוסטר המתכת שלכם';
    wrap.appendChild(flatImg);
    stage.appendChild(wrap);
    updatePreview();
  }
  function updatePreview() {
    var has = !!srcImg;
    if (has) renderCrop(texCanvas, 1400);
    if (stage) {
      $('mtp-stage-cta').hidden = has || uploading;
      $('mtp-stage-hint').hidden = !(viewer && has);
    }
    if (viewer) {
      viewer.setOrientation(state.orientation);
      viewer.setFinish(state.finish);
      viewer.setImage(has ? texCanvas : null);
    } else if (flatImg) {
      flatImg.src = has ? texCanvas.toDataURL('image/jpeg', 0.85) : '';
      flatImg.hidden = !has;
    }
    var small = has ? renderCrop(document.createElement('canvas'), 240).toDataURL('image/jpeg', 0.8) : '';
    if (has) $('mtp-thumb').src = small;
    var t3 = $('mtg-3d-thumb');
    if (t3) {
      t3.hidden = !has;
      if (has) t3.src = small;
      $('mtg-3d-icon').hidden = has;
    }
  }

  // ---------- Upload ----------
  function pickFile() { $('mtp-file').click(); }
  $('mtp-pick').addEventListener('click', pickFile);
  $('mtp-pick').addEventListener('pointerdown', ensure3D); // start loading 3D while the customer picks a photo
  $('mtp-replace').addEventListener('click', pickFile);
  $('mtp-edit').addEventListener('click', function () { openCrop(); });
  $('mtp-remove').addEventListener('click', function () { resetForNew(); show(1 < slides.length ? 1 : 0); });
  $('mtp-file').addEventListener('change', function (e) {
    var f = e.target.files && e.target.files[0];
    e.target.value = '';
    if (f) startUpload(f);
  });

  function loadImage(url, cors) {
    return new Promise(function (res, rej) {
      var im = new Image();
      if (cors) im.crossOrigin = 'anonymous';
      im.onload = function () { res(im); };
      im.onerror = rej;
      im.src = url;
    });
  }
  function startUpload(file) {
    var token = ++uploadToken;
    state.url = ''; state.natW = state.natH = 0;
    state.cropXf = 0; state.cropYf = 0; state.cropScale = 1;
    state.fileName = file.name || 'התמונה שלכם';
    srcImg = null;
    uploading = true; uploadPct = 0;
    ensure3D();
    showPhotoRow();
    paintButton();
    openCrop(true); // spinner until the image is ready
    // Instant local preview when the browser can decode the file (HEIC usually waits for the upload)
    var local = URL.createObjectURL(file);
    loadImage(local, false).then(function (im) {
      if (token !== uploadToken || srcImg) return null;
      // A plain (SDR) copy: iPhones show HDR photos brighter on screen, so showing the original made the crop
      // look brighter than the 3D and the print. Crop, 3D and cart now all use the same copy.
      return toPlainCopy(im).then(function (copy) {
        URL.revokeObjectURL(local);
        if (token === uploadToken && !srcImg) useImage(copy, im.naturalWidth, im.naturalHeight, true);
      });
    }, function () {}).then(function () {
      if (token === uploadToken) sendUpload(file, token);
    });
  }
  function sendUpload(file, token) {
    MTH.upload(file, function (pct) { if (token === uploadToken) { uploadPct = pct; paintButton(); } }).then(function (r) {
      if (token !== uploadToken) return;
      state.url = r.url;
      if (r.width && r.height) { state.natW = r.width; state.natH = r.height; }
      if (srcImg) { uploading = false; changed(); return; }
      loadImage(MTH.displayUrl(state.url), true).then(function (im) {
        if (token !== uploadToken) return;
        uploading = false;
        useImage(im, state.natW || im.naturalWidth, state.natH || im.naturalHeight, true);
      }, function () { uploadFailed('התמונה עלתה אבל לא הצלחנו לפתוח אותה. נסו תמונה בפורמט JPG או PNG.'); });
    }, function (msg) { if (token === uploadToken) uploadFailed(msg); });
  }
  function uploadFailed(message) {
    uploading = false;
    closeCrop();
    srcImg = null; state.url = '';
    changed();
    window.alert(message || 'לא הצלחנו להעלות את התמונה. נסו שוב.');
  }
  function toPlainCopy(im) {
    return new Promise(function (resolve) {
      var k = Math.min(1, 2400 / Math.max(im.naturalWidth, im.naturalHeight));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(im.naturalWidth * k));
      c.height = Math.max(1, Math.round(im.naturalHeight * k));
      c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
      c.toBlob(function (b) {
        if (!b) { resolve(im); return; }
        loadImage(URL.createObjectURL(b), false).then(resolve, function () { resolve(im); });
      }, 'image/jpeg', 0.92);
    });
  }
  function useImage(im, natW, natH, autoOrient) {
    srcImg = im;
    if (!state.natW) { state.natW = natW; state.natH = natH; }
    if (autoOrient) state.orientation = natW > natH * 1.05 ? 'landscape' : 'portrait';
    changed();
    if (cropOpen) refreshCrop(true);
  }
  function showPhotoRow() {
    var has = uploading || !!srcImg || !!state.url;
    $('mtp-pick').hidden = has;
    $('mtp-photo').hidden = !has;
    $('mtp-notes-wrap').hidden = !has;
    $('mtp-filename').textContent = state.fileName || 'התמונה שלכם';
    paintQuality($('mtp-quality'));
  }

  // ---------- Add-to-cart button ----------
  function paintButton() {
    var b = $('mtp-add');
    var v = variantFor(state.size, state.finish);
    var eff = v ? effectivePrice(v.price) : 0;
    var price = !v ? '' : ' · ' + (eff < v.price ? '<s>' + money(v.price) + '</s> ' + money(eff) : money(v.price));
    if (!v || !v.available) { b.disabled = true; b.textContent = 'האפשרות הזו לא זמינה כרגע'; }
    else if (!srcImg && !state.url) { b.disabled = true; b.innerHTML = 'הוספה לסל' + price; }
    else if (uploading) { b.disabled = true; b.textContent = 'מעלה את התמונה… ' + uploadPct + '%'; }
    else { b.disabled = false; b.innerHTML = (editingSessionId ? 'עדכון בסל' : 'הוספה לסל') + price; }
    paintSticky();
  }
  function changed() {
    renderOptions();
    showPhotoRow();
    paintButton();
    paintSticky();
    if (cropOpen) refreshCrop(false);
    updatePreview();
    schedulePrep();
  }

  // ---------- Sticky bottom button (phones): "העלאת תמונה" before a photo, "הוספה לסל" after ----------
  // Shows only while the page's own button is out of view.
  var sticky = document.createElement('div'), stickyBtn = null;
  sticky.className = 'mtp-sticky';
  sticky.dir = 'rtl';
  sticky.innerHTML = '<button type="button" class="mtp-sticky-btn" id="mtp-sticky-btn"></button>';
  document.body.appendChild(sticky);
  stickyBtn = $('mtp-sticky-btn');
  var inView = { pick: true, add: true };
  function paintSticky() {
    if (!stickyBtn) return; // early calls during start-up
    var has = !!srcImg || !!state.url;
    var target = has ? $('mtp-add') : $('mtp-pick');
    var away = has ? !inView.add : !inView.pick;
    if (has) {
      stickyBtn.innerHTML = $('mtp-add').innerHTML;
      stickyBtn.disabled = $('mtp-add').disabled;
      stickyBtn.classList.remove('is-upload');
    } else {
      stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>העלאת תמונה';
      stickyBtn.disabled = false;
      stickyBtn.classList.add('is-upload');
    }
    var on = away && !!target && !cropOpen;
    sticky.classList.toggle('is-on', on);
    document.documentElement.classList.toggle('mtp-sticky-on', on);
  }
  stickyBtn.addEventListener('click', function () {
    if (srcImg || state.url) addToCart(); else pickFile();
  });
  if ('IntersectionObserver' in window) {
    var stickyIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { inView[e.target.id === 'mtp-add' ? 'add' : 'pick'] = e.isIntersecting; });
      paintSticky();
    });
    stickyIO.observe($('mtp-pick'));
    stickyIO.observe($('mtp-add'));
  }

  // ---------- Full-screen crop ----------
  var cropOpen = false;
  var crop = document.createElement('div');
  crop.className = 'mtp-crop';
  crop.dir = 'rtl';
  crop.setAttribute('role', 'dialog');
  crop.setAttribute('aria-modal', 'true');
  crop.setAttribute('aria-label', 'מיקום התמונה בפוסטר');
  crop.innerHTML =
    '<div class="mtp-crop-top"><span class="mtp-crop-title" id="mtp-crop-title"></span><span class="mtp-q" id="mtp-crop-q"></span></div>' +
    '<p class="mtp-crop-note" id="mtp-crop-note">&#10024; אזורים ריקים יושלמו באופן טבעי בעזרת AI</p>' +
    '<div class="mtp-crop-stage">' +
      '<div class="mtp-crop-canvas" id="mtp-crop-canvas" dir="ltr">' +
        '<div class="mtp-ghost-wrap"><img class="mtp-ghost" id="mtp-ghost" alt="" draggable="false"></div>' +
        '<div class="mtp-clip"><img class="mtp-real" id="mtp-real" alt="" draggable="false"><div class="mtp-crop-spin" id="mtp-crop-spin"><div class="mtp-spinner"></div></div></div>' +
      '</div>' +
      '<p class="mtp-crop-hint">צבטו או גררו כדי למקם את התמונה</p>' +
    '</div>' +
    '<div class="mtp-crop-bar">' +
      '<button type="button" class="mtp-bar-btn" id="mtp-crop-replace"><svg viewBox="0 0 24 24"><path d="M12 16V4M7 9l5-5 5 5"/><path d="M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg><span>החלפה</span></button>' +
      '<div class="mtp-crop-mid">' +
        '<button type="button" class="mtp-bar-btn" id="mtp-crop-orient"><svg viewBox="0 0 24 24"><rect id="mtp-crop-orient-r" x="6" y="3" width="12" height="18" rx="1.5"/><path id="mtp-crop-orient-p" d="M3 9a9 9 0 0 1 3-4"/></svg><span id="mtp-crop-orient-l"></span></button>' +
        '<button type="button" class="mtp-bar-btn" id="mtp-crop-bw"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M12 3a9 9 0 0 1 0 18z" fill="currentColor"/></svg><span>שחור-לבן</span></button>' +
      '</div>' +
      '<button type="button" class="mtp-crop-done" id="mtp-crop-done">סיום</button>' +
    '</div>';
  document.body.appendChild(crop);
  var busy = document.createElement('div');
  busy.className = 'mtp-busy';
  busy.dir = 'rtl';
  busy.innerHTML = '<div class="mtp-spinner"></div><p>מכינים את ההזמנה שלכם&#8230;</p>';
  document.body.appendChild(busy);

  var cropCanvas = $('mtp-crop-canvas'), realImg = $('mtp-real'), ghostImg = $('mtp-ghost');

  function cropPx() {
    var r = ratio();
    var avH = window.innerHeight - 230, avW = window.innerWidth - 48;
    var maxH = Math.min(avH, 620), w, h;
    if (r >= 1) {
      w = Math.min(avW, maxH * r, 760); h = Math.round(w / r);
      if (h > maxH) { h = maxH; w = Math.round(h * r); }
    } else {
      h = maxH; w = Math.round(h * r);
      if (w > avW) { w = avW; h = Math.round(w / r); }
    }
    return { w: Math.round(w), h: Math.round(h) };
  }
  function imgFill(px) {
    var r = srcImg ? srcImg.naturalWidth / srcImg.naturalHeight : 1;
    return r >= px.w / px.h ? { iW: Math.round(px.h * r), iH: px.h } : { iW: px.w, iH: Math.round(px.w / r) };
  }
  function constrain(px) {
    var d = imgFill(px), s = state.cropScale;
    var maxX = Math.abs(d.iW * s - px.w) / 2, maxY = Math.abs(d.iH * s - px.h) / 2;
    state.cropXf = Math.max(-maxX / px.w, Math.min(maxX / px.w, state.cropXf));
    state.cropYf = Math.max(-maxY / px.h, Math.min(maxY / px.h, state.cropYf));
  }
  function sizeImg(el, px) {
    var d = imgFill(px);
    el.style.width = d.iW + 'px'; el.style.height = d.iH + 'px';
    el.style.marginLeft = -(d.iW / 2) + 'px'; el.style.marginTop = -(d.iH / 2) + 'px';
  }
  function syncCrop(px) {
    var t = 'translate(' + state.cropXf * px.w + 'px,' + state.cropYf * px.h + 'px) scale(' + state.cropScale + ')';
    realImg.style.transform = ghostImg.style.transform = t;
    realImg.style.filter = ghostImg.style.filter = state.effect === 'bw' ? 'grayscale(100%)' : '';
    $('mtp-crop-note').classList.toggle('is-show', state.cropScale < 1);
    paintQuality($('mtp-crop-q'));
  }
  function refreshCrop(newImage) {
    var px = cropPx();
    cropCanvas.style.width = px.w + 'px';
    cropCanvas.style.height = px.h + 'px';
    $('mtp-crop-title').textContent = dimsLabel(state.size) + ' ס״מ · ' + orientLabel();
    $('mtp-crop-orient-l').textContent = state.orientation === 'portrait' ? 'לרוחב' : 'לאורך';
    // The icon shows the shape the button switches to (wide for "לרוחב", tall for "לאורך")
    var toLand = state.orientation === 'portrait', r = $('mtp-crop-orient-r');
    r.setAttribute('x', toLand ? 3 : 6); r.setAttribute('y', toLand ? 7 : 3);
    r.setAttribute('width', toLand ? 18 : 12); r.setAttribute('height', toLand ? 12 : 18);
    $('mtp-crop-orient-p').setAttribute('d', toLand ? 'M15 4a9 9 0 0 1 4 2' : 'M3 9a9 9 0 0 1 3-4');
    $('mtp-crop-bw').classList.toggle('is-on', state.effect === 'bw');
    $('mtp-crop-spin').hidden = !!srcImg;
    realImg.hidden = ghostImg.hidden = !srcImg;
    if (srcImg) {
      if (newImage || realImg.src !== srcImg.src) realImg.src = ghostImg.src = srcImg.src;
      sizeImg(realImg, px); sizeImg(ghostImg, px);
      constrain(px);
      syncCrop(px);
    }
  }
  function openCrop(waiting) {
    if (!srcImg && !waiting) return;
    cropOpen = true;
    document.documentElement.classList.add('mtp-lock');
    paintSticky();
    refreshCrop(true);
    requestAnimationFrame(function () { crop.classList.add('is-open'); });
  }
  function closeCrop() {
    if (!cropOpen) return;
    cropOpen = false;
    crop.classList.remove('is-open');
    ghostImg.classList.remove('is-show');
    document.documentElement.classList.remove('mtp-lock');
    updatePreview();
    showPhotoRow();
    paintSticky();
    schedulePrep();
    if (srcImg) { show(0); scrollToGallery(); }
  }
  function scrollToGallery() {
    if (!gallery) return;
    var r = gallery.getBoundingClientRect();
    if (r.top < 0 || r.bottom > window.innerHeight) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  $('mtp-crop-done').addEventListener('click', closeCrop);
  $('mtp-crop-replace').addEventListener('click', pickFile);
  $('mtp-crop-orient').addEventListener('click', function () { setOrientation(state.orientation === 'portrait' ? 'landscape' : 'portrait'); });
  $('mtp-crop-bw').addEventListener('click', function () { state.effect = state.effect === 'bw' ? 'original' : 'bw'; changed(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (cropOpen) closeCrop(); else closeAdded();
  });

  // Drag / pinch / wheel, ported from the Tiles crop view
  var act = { panning: false, pinching: false, sx: 0, sy: 0, bx: 0, by: 0, pd: 0, bs: 1 };
  function startPan(x, y) { act.panning = true; act.pinching = false; act.sx = x; act.sy = y; act.bx = state.cropXf; act.by = state.cropYf; ghostImg.classList.add('is-show'); }
  function endGesture() { act.panning = act.pinching = false; ghostImg.classList.remove('is-show'); }
  cropCanvas.addEventListener('mousedown', function (e) { if (!srcImg || e.button !== 0) return; e.preventDefault(); startPan(e.clientX, e.clientY); });
  document.addEventListener('mousemove', function (e) {
    if (!act.panning || !cropOpen) return;
    var px = cropPx();
    state.cropXf = act.bx + (e.clientX - act.sx) / px.w;
    state.cropYf = act.by + (e.clientY - act.sy) / px.h;
    constrain(px); syncCrop(px);
  });
  document.addEventListener('mouseup', function () { if (act.panning) endGesture(); });
  cropCanvas.addEventListener('wheel', function (e) {
    if (!srcImg) return;
    e.preventDefault();
    var px = cropPx();
    state.cropScale = Math.max(0.5, Math.min(4, state.cropScale - e.deltaY * 0.003));
    constrain(px); syncCrop(px);
  }, { passive: false });
  cropCanvas.addEventListener('touchstart', function (e) {
    if (!srcImg) return;
    e.preventDefault();
    if (e.touches.length === 1) startPan(e.touches[0].clientX, e.touches[0].clientY);
    else if (e.touches.length === 2) {
      var dx = e.touches[0].clientX - e.touches[1].clientX, dy = e.touches[0].clientY - e.touches[1].clientY;
      act.panning = false; act.pinching = true; act.pd = Math.sqrt(dx * dx + dy * dy); act.bs = state.cropScale;
      ghostImg.classList.add('is-show');
    }
  }, { passive: false });
  cropCanvas.addEventListener('touchmove', function (e) {
    if (!srcImg) return;
    e.preventDefault();
    var px = cropPx();
    if (act.panning && e.touches.length === 1) {
      state.cropXf = act.bx + (e.touches[0].clientX - act.sx) / px.w;
      state.cropYf = act.by + (e.touches[0].clientY - act.sy) / px.h;
    } else if (act.pinching && e.touches.length === 2) {
      var dx = e.touches[0].clientX - e.touches[1].clientX, dy = e.touches[0].clientY - e.touches[1].clientY;
      state.cropScale = Math.max(0.5, Math.min(4, act.bs * (Math.sqrt(dx * dx + dy * dy) / act.pd)));
    }
    constrain(px); syncCrop(px);
  }, { passive: false });
  cropCanvas.addEventListener('touchend', function (e) {
    if (e.touches.length === 0) endGesture();
    else if (e.touches.length === 1) startPan(e.touches[0].clientX, e.touches[0].clientY);
  });
  window.addEventListener('resize', function () { if (cropOpen) refreshCrop(false); });

  // ---------- Session (cart "עריכה") ----------
  function saveSession() {
    var sid = 'mtp_' + Date.now().toString(36) + Math.random().toString(36).substr(2, 6);
    try { localStorage.setItem(SESSION_PREFIX + sid, JSON.stringify(state)); } catch (e) {}
    return sid;
  }
  function restoreSession(sid) {
    var raw = null, s;
    try { raw = localStorage.getItem(SESSION_PREFIX + sid); } catch (e) {}
    if (!raw) return;
    try { s = JSON.parse(raw); } catch (e) { return; }
    if (!s || !s.url) return;
    Object.keys(state).forEach(function (k) { if (s[k] !== undefined) state[k] = s[k]; });
    $('mtp-notes').value = state.notes || '';
    editingSessionId = sid;
    uploading = true; // until the image is decoded
    showPhotoRow(); paintButton();
    show(0);
    loadImage(MTH.displayUrl(state.url), true).then(function (im) {
      uploading = false;
      srcImg = im;
      changed();
    }, function () { uploading = false; changed(); });
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      editingCartKeys = (cart.items || []).filter(function (it) {
        return ((it.properties || {})['_Session ID'] || '').trim() === sid;
      }).map(function (it) { return it.key; });
      refreshCartPosters(); // the poster being edited doesn't count toward its own discount price
    }).catch(function () { editingCartKeys = []; });
  }
  $('mtp-notes').addEventListener('input', function (e) { state.notes = e.target.value; });

  // ---------- Add to cart ----------
  var adding = false;
  // The cart preview upload and the print-file check run in the background as soon as the photo, crop, size or
  // effect settle, so "Add to cart" usually only has to add the line (~1 s instead of ~3 s).
  var prep = null, prepTimer = null;
  function prepKey() { return JSON.stringify(printSpec()); }
  function startPrep() {
    var k = prepKey();
    if (prep && prep.key === k) return prep.promise;
    prep = { key: k, promise: Promise.all([uploadPreview(), MTH.printFile(printSpec())]) };
    return prep.promise;
  }
  function schedulePrep() {
    clearTimeout(prepTimer);
    if (!srcImg || !state.url || uploading || cropOpen) return;
    prepTimer = setTimeout(function () { if (srcImg && state.url && !uploading && !cropOpen && !adding) startPrep(); }, 700);
  }
  function uploadPreview() {
    return new Promise(function (resolve) {
      renderCrop(document.createElement('canvas'), 600).toBlob(function (blob) {
        if (!blob) { resolve(null); return; }
        var fd = new FormData();
        fd.append('file', blob, 'preview.jpg');
        fd.append('upload_preset', PRESET);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://api.cloudinary.com/v1_1/' + CLOUD + '/image/upload');
        xhr.onload = function () { try { resolve(JSON.parse(xhr.responseText).secure_url || null); } catch (e) { resolve(null); } };
        xhr.onerror = function () { resolve(null); };
        xhr.send(fd);
      }, 'image/jpeg', 0.88);
    });
  }
  function removeKeys(keys) {
    return keys.reduce(function (chain, key) {
      return chain.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        }).catch(function () {});
      });
    }, Promise.resolve());
  }
  function addToCart() {
    if (adding || uploading || !state.url) return;
    var v = variantFor(state.size, state.finish);
    if (!v) return;
    adding = true;
    var busyTimer = setTimeout(function () { busy.classList.add('is-on'); }, 250); // no flash when it's quick
    var wasEditing = !!editingSessionId;
    var oldKeys = editingCartKeys.slice();
    state.notes = ($('mtp-notes').value || '').trim();
    var sid = saveSession();
    clearTimeout(prepTimer);
    Promise.all([removeKeys(oldKeys), startPrep()]).then(function (all) {
      var res = [null, all[1][0], all[1][1]];
      var props = {
        '_Image URL': state.url,
        'כיוון': orientLabel(),
        'אפקט': state.effect === 'bw' ? 'שחור לבן' : 'מקורי'
      };
      if (state.notes) props['בקשות עריכה מיוחדות'] = state.notes;
      props['_Session ID'] = sid;
      props['_Builder'] = 'poster';
      if (res[1]) props['_Preview URL'] = res[1];
      if (res[2]) props['_Print File'] = res[2];
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1, properties: props }] })
      });
    }).then(function (r) { return r.json(); }).then(function (d) {
      adding = false;
      clearTimeout(busyTimer);
      busy.classList.remove('is-on');
      if (d && d.status) { window.alert('לא הצלחנו להוסיף לסל: ' + (d.description || 'נסו שוב.')); return; }
      resetForNew();
      refreshCartBubble();
      refreshCartPosters();
      openAdded(wasEditing);
    }).catch(function () {
      adding = false;
      clearTimeout(busyTimer);
      busy.classList.remove('is-on');
      window.alert('לא הצלחנו להוסיף לסל. נסו שוב.');
    });
  }
  $('mtp-add').addEventListener('click', addToCart);

  // Fresh builder for the next poster (size and finish stay as chosen)
  function resetForNew() {
    uploadToken++;
    uploading = false;
    srcImg = null;
    state.url = ''; state.natW = state.natH = 0; state.fileName = '';
    state.cropXf = 0; state.cropYf = 0; state.cropScale = 1;
    state.effect = 'original'; state.notes = '';
    $('mtp-notes').value = '';
    editingSessionId = null; editingCartKeys = [];
    try {
      var u = new URL(window.location.href);
      if (u.searchParams.has('session')) { u.searchParams.delete('session'); history.replaceState(null, '', u.pathname + u.search + u.hash); }
    } catch (e) {}
    changed();
  }
  function refreshCartBubble() {
    fetch('/?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (s) {
      var el = $('cart-icon-bubble');
      if (!el || !s['cart-icon-bubble']) return;
      var sec = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
      if (sec) el.innerHTML = sec.innerHTML;
    }).catch(function () {});
  }

  // ---------- "Added to cart" panel: checkout or add another poster ----------
  var added = document.createElement('div');
  added.className = 'mtp-added';
  added.dir = 'rtl';
  added.setAttribute('role', 'dialog');
  added.setAttribute('aria-modal', 'true');
  added.setAttribute('aria-labelledby', 'mtp-added-title');
  added.hidden = true;
  added.innerHTML =
    '<div class="mtp-added-bg" id="mtp-added-bg"></div>' +
    '<div class="mtp-added-box">' +
      '<div class="mtp-added-head">' +
        '<span class="mtp-added-check"><svg viewBox="0 0 24 24"><polyline points="5 12 10 17 19 7"/></svg></span>' +
        '<p class="mtp-added-title" id="mtp-added-title"></p>' +
        '<button type="button" class="mtp-added-x" id="mtp-added-x" aria-label="סגירה"><svg viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button>' +
      '</div>' +
      '<div class="mtp-added-list" id="mtp-added-list"></div>' +
      '<button type="button" class="mtp-added-promo" id="mtp-added-promo" hidden></button>' +
      '<div class="mtp-added-actions">' +
        '<a class="mtp-added-go" href="/cart" id="mtp-added-go">מעבר לסל ולתשלום</a>' +
        '<button type="button" class="mtp-added-more" id="mtp-added-more"><svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>הוספת פוסטר נוסף</button>' +
      '</div>' +
    '</div>';
  document.body.appendChild(added);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function sized(url, w) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  // The offer never guesses the next poster's size (people mix sizes): it shows what the posters already in the
  // cart will cost once the next tier applies, and that the next poster gets the same discount.
  function promoHtml(n, posterTotal) {
    if (CFG.promo === 'none' || !n) return '';
    if (CFG.promo) return '<span class="mtp-promo-title">' + esc(CFG.promo) + '</span>';
    var price = function (base, pct) { return '<s>' + money(base) + '</s> <b>' + money(Math.round(base * (1 - pct))) + '</b>'; };
    var cta = '<span class="mtp-promo-cta">הוספת פוסטר נוסף ←</span>';
    if (n >= 3) {
      return '<span class="mtp-promo-title">🎉 יש לכם 30% הנחה על כל הפוסטרים</span>' +
        '<span class="mtp-promo-sub">הפוסטרים בסל: ' + price(posterTotal, 0.3) + '</span>' +
        '<span class="mtp-promo-sub">וכל פוסטר נוסף גם ב-30% הנחה</span>' + cta;
    }
    var off = tierFor(n + 1), pct = Math.round(off * 100);
    return '<span class="mtp-promo-title">🎁 עוד פוסטר אחד = ' + pct + '% הנחה על כל הפוסטרים</span>' +
      '<span class="mtp-promo-sub">' + (n === 1 ? 'הפוסטר שכבר בסל יירד ל: ' : 'הפוסטרים שכבר בסל יירדו ל: ') + price(posterTotal, off) + '</span>' +
      '<span class="mtp-promo-sub">והפוסטר החדש גם ב-' + pct + '% הנחה</span>' + cta;
  }
  function itemHtml(it) {
    var p = it.properties || {};
    var img = p['_Preview URL'] || sized(it.image, 160);
    var meta = [it.variant_title, p['כיוון']].filter(Boolean).join(' · ');
    return '<div class="mtp-added-item">' +
      (img ? '<img src="' + esc(img) + '" alt="" width="52" height="64" loading="lazy">' : '') +
      '<div class="mtp-added-info"><span class="mtp-added-name">' + esc(it.product_title) + '</span>' +
      '<span class="mtp-added-meta">' + esc(meta) + (it.quantity > 1 ? ' · ×' + it.quantity : '') + '</span></div>' +
      '<span class="mtp-added-price">' + money(it.final_line_price) + '</span></div>';
  }
  function openAdded(updated) {
    $('mtp-added-title').textContent = updated ? 'הפוסטר עודכן בסל' : 'הפוסטר נוסף לסל';
    var list = $('mtp-added-list');
    list.innerHTML = '<div class="mtp-spinner" style="margin:10px auto"></div>';
    $('mtp-added-promo').hidden = true;
    added.hidden = false;
    requestAnimationFrame(function () { added.classList.add('is-open'); });
    document.documentElement.classList.add('mtp-lock');
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var ids = CFG.posterProductIds || [];
      var posters = (cart.items || []).filter(function (it) { return ids.indexOf(it.product_id) > -1; });
      var others = (cart.items || []).filter(function (it) { return ids.indexOf(it.product_id) < 0; });
      var n = 0, total = 0;
      posters.forEach(function (it) { n += it.quantity; total += it.original_line_price; });
      var otherCount = 0;
      others.forEach(function (it) { otherCount += it.quantity; });
      list.innerHTML = posters.map(itemHtml).join('') +
        (otherCount ? '<p class="mtp-added-more-items">+ עוד ' + otherCount + ' ' + (otherCount === 1 ? 'פריט' : 'פריטים') + ' בסל</p>' : '');
      var promo = promoHtml(n, total);
      $('mtp-added-promo').hidden = !promo;
      $('mtp-added-promo').innerHTML = promo;
    }).catch(function () { list.innerHTML = ''; });
    setTimeout(function () { $('mtp-added-go').focus(); }, 350);
  }
  function closeAdded() {
    if (added.hidden) return;
    added.classList.remove('is-open');
    document.documentElement.classList.remove('mtp-lock');
    setTimeout(function () { added.hidden = true; }, 320);
  }
  $('mtp-added-x').addEventListener('click', closeAdded);
  $('mtp-added-bg').addEventListener('click', closeAdded);
  function addAnother() {
    closeAdded();
    show(0);
    pickFile(); // inside the tap, so phones open the photo picker
  }
  $('mtp-added-more').addEventListener('click', addAnother);
  $('mtp-added-promo').addEventListener('click', addAnother);

  // ---------- "לצפייה במידות" / "לצפייה בהשוואה": image popup ----------
  var shot = document.createElement('div');
  shot.className = 'mtp-shot';
  shot.dir = 'rtl';
  shot.hidden = true;
  shot.setAttribute('role', 'dialog');
  shot.setAttribute('aria-modal', 'true');
  shot.innerHTML = '<div class="mtp-shot-box"><button type="button" class="mtp-added-x mtp-shot-x" aria-label="סגירה"><svg viewBox="0 0 24 24"><line x1="6" y1="6" x2="18" y2="18"/><line x1="18" y1="6" x2="6" y2="18"/></svg></button><img alt=""></div>';
  document.body.appendChild(shot);
  function closeShot() { shot.hidden = true; document.documentElement.classList.remove('mtp-lock'); }
  shot.addEventListener('click', function (e) { if (e.target === shot || e.target.closest('.mtp-shot-x')) closeShot(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !shot.hidden) closeShot(); });
  Array.prototype.forEach.call(root.querySelectorAll('[data-mtp-show]'), function (b) {
    var src = CFG[b.getAttribute('data-mtp-show')];
    if (!src) { b.hidden = true; return; }
    b.addEventListener('click', function () {
      var im = shot.querySelector('img');
      im.src = src;
      im.alt = b.textContent;
      shot.hidden = false;
      document.documentElement.classList.add('mtp-lock');
    });
  });

  // ---------- Boot ----------
  renderOptions();
  showPhotoRow();
  paintButton();
  updatePreview();
  if (cur === 0) show(0); // the page opens on the 3D view
  refreshCartPosters();
  try {
    var sid = new URLSearchParams(window.location.search).get('session');
    if (sid) restoreSession(sid);
  } catch (e) {}
})();
